export enum AssetTypeEnum {
  image = 'image',
  document = 'document',
  video = 'video',
  raw = 'raw',
}

export enum ImageSizeEnum {
  original = 'original',
  thumb = 'thumb',
  small = 'small',
  medium = 'medium',
  large = 'large',
  xlarge = 'xlarge',
}
